module.exports = __webpack_public_path__ + "static/media/end_of_lesson.c38d7148.svg";